@if (header1) {
  <header [ngClass]="light ? 'mb-10 text-white' : contained ? 'my-12 text-black' : 'my-12 max-w-screen-xl px-4 mx-auto sm:px-6 lg:px-8 text-black'">
    <h1 class="font-bold tracking-wide text-5xl" [ngClass]="light ? 'text-white' : 'text-gray-700'">{{header1}}</h1>
    @if (header2) {
      <h2 class="mt-4 font-semibold tracking-wide text-md" [ngClass]="light ? 'max-w-xl text-white/80' : 'w-2/3 text-gray-700'">
        {{header2}}
      </h2>
    }
    <span class="inline-block h-1 w-40 rounded-full" [ngClass]="light ? 'bg-white/70' : 'bg-gray-500'"></span>
    <span class="ml-1 inline-block h-1 w-3 rounded-full" [ngClass]="light ? 'bg-white/70' : 'bg-gray-500'"></span>
    <span class="ml-1 inline-block h-1 w-1 rounded-full" [ngClass]="light ? 'bg-white/70' : 'bg-gray-500'"></span>
  </header>
}
